// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 3524 ? "app" : chunkId) + "." + {"3524":"6b6f6d83105148324dc9","4120":"8674eac098b2d14240e0"}[chunkId] + ".css";
};